// eslint-disable-next-line import/prefer-default-export
export const getActiveChapter = (state) => state.learningCommunity.activeChapter;

export const getActiveChapterDuration = (state) => state.learningCommunity.activeChapterDuration;

export const getActiveVolume = (state) => state.learningCommunity.activeVolume;

export const isLoading = (state) => state.isLoading;
